import {
    API_CMND,
} from "../constants/apiEndPoints";

import {axiosBodyToAPI} from '../commons/shared';

export const fetchPostCMNDApi = (params = {}) => {
    const body = params;
    return axiosBodyToAPI('POST', API_CMND, body);
};